import { injectable } from 'inversify';

import api from '../axios-config';

export interface ICode {
  exists: boolean;
}

export const CLINICS_SERVICE = Symbol.for('CLINICS_SERVICE');

export interface IClinicsService {
  validateCode(signUpCode: string): Promise<object>;
  getById(id: number): Promise<{ id: number; name: string }>;
}

@injectable()
export class ClinicsService implements IClinicsService {
  async validateCode(signUpCode: string): Promise<ICode> {
    const response = await api.get(`/api/clinics/${signUpCode}`);
    return response.data;
  }

  async getById(id: number): Promise<{ id: number; name: string }> {
    const response = await api.get<{ id: number; name: string }>(`/api/clinic/by-id/${id}`);
    return response.data;
  }
}
